
import {
  LeasingSearchFormValues,
  LeasingEditFormValues,
  LeasingDetailFormValues,
} from "./types";


/*-------------------------------------------------------------------------------------------
  CALCULATION SETTING - LEASING SEARCH
---------------------------------------------------------------------------------------------*/
export const initialLeasingSearchForm: LeasingSearchFormValues =
  {
    search: "",
  };

/*-------------------------------------------------------------------------------------------
    CALCULATION SETTING - LEASING EDIT
---------------------------------------------------------------------------------------------*/

export const initialLeasingEditForm: LeasingEditFormValues =
  {
    leasingTypeId: null,
    name: null,
    interestRate: null,
  };

/*-------------------------------------------------------------------------------------------
    CALCULATION SETTING - LEASING DETAIL
---------------------------------------------------------------------------------------------*/

export const initialLeasingDetailForm: LeasingDetailFormValues =
  {
    id: null,
    leasingTypeId: null,
    leasingTypeName: null,
    name: null,
    interestRate: null,
  };

